/**
 * Comic steps — the "komiks" variant of process-comic: round illustrations that turn over
 * to show what happens in each step.
 *
 * Hover and keyboard focus are pure CSS. This only adds the two things CSS can't do:
 *  - a tap toggles a coin on touch screens (and turns the others back, so the strip reads
 *    like a hand of cards rather than a row of switches);
 *  - the first time the strip scrolls into view, the first coin peeks over once, so a
 *    visitor learns they move at all without being told.
 */
export function comicSteps() {
  const sections = document.querySelectorAll('[data-comic-steps]');
  if (!sections.length) return;

  // Where there's a real hover, hover already turns the coin, and a click toggling state
  // underneath the pointer would only desync the two. Taps are the case to handle.
  const hasHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  sections.forEach((section) => {
    const coins = [...section.querySelectorAll('.process-toon__coin')];

    coins.forEach((coin) => {
      coin.addEventListener('click', () => {
        if (hasHover.matches) return;
        const turning = coin.getAttribute('aria-pressed') !== 'true';
        coins.forEach((other) => other.setAttribute('aria-pressed', 'false'));
        coin.setAttribute('aria-pressed', turning ? 'true' : 'false');
      });
    });

    if (reduceMotion.matches || !('IntersectionObserver' in window) || !coins.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        coins[0].classList.add('is-peeking');
        coins[0].addEventListener('animationend', () => coins[0].classList.remove('is-peeking'), { once: true });
      },
      { threshold: 0.45 },
    );
    observer.observe(section.querySelector('.process-toon__steps') || section);
  });
}
